import script from "./PlatMapPreview.vue?vue&type=script&setup=true&lang=ts"
export * from "./PlatMapPreview.vue?vue&type=script&setup=true&lang=ts"

import "./PlatMapPreview.vue?vue&type=style&index=0&id=0f1daf89&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0f1daf89"]])

export default __exports__